export default __webpack_public_path__ + "static/media/050_brake.first.4830bcc3.png";